import React, { useState } from 'react';
import { Button, TextField, Box } from '@mui/material';
import EnhancedTable from './EnhancedTable';
import { useAuthContext } from '../hooks/useAuthContext';

export default function FirmwareUpgrade() {
  const { user } = useAuthContext();
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      alert('Please select a file before uploading.');
      return;
    }

    const formData = new FormData();
    formData.append('firmware', selectedFile);

    try {
      const response = await fetch('/api/v1/firmware', {
        method: 'POST',
        headers: { Authorization: `Bearer ${user.token}` },
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Failed to upload firmware');
      }

      const result = await response.json();
      console.log('Upload successful:', result);
      alert('Firmware uploaded successfully!');
    } catch (error) {
      console.error('Error uploading firmware:', error);
      alert('Failed to upload firmware. Please try again.');
    }
  };

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '300px', margin: 'auto' }}>
        <TextField
          type="file"
          inputProps={{ accept: '.bin,.hex' }} // 限制檔案類型
          onChange={handleFileChange}
          fullWidth
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleUpload}
          disabled={!selectedFile}
        >
          Upload Firmware
        </Button>
      </Box>
      <Box sx={{ marginTop: 4 }} /> {/* 增加間距 */}
      <EnhancedTable />
    </>
  );
}